import interruptionPoint from './interruption-points';

const registerInterruptionPoint = (actionType, matcher) => {
  interruptionPoint.set(actionType, matcher);
};

export default registerInterruptionPoint;
